import { callFesWithLoading } from '../index';

export interface ValidateIBANResponse {
  isValid: boolean;
  paymentData?: {
    bic: string;
  };
}

export const validateIBAN = async (iban: string): Promise<ValidateIBANResponse> => {
  return callFesWithLoading.post(`iban-service/validate-iban`, { iban }, true);
};
